import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"
import {
    addBookmarkUsingDataApi,
    removeBookmarkUsingDataApi,
    findBookmarkUsingDataApi,
} from "../../apis/bookmark"
import { GlobalState } from "../../store"
import { IDataAPIBookmarkButton } from "./index"

const initialState: IDataAPIBookmarkButton = {
    isLoading: false,
    resourceType: "Item",
    bookmarkId: null,
    resourceId: null,
}

export const bookmarkSlice = createSlice({
    name: "DataApiBookmark",
    initialState: initialState,
    reducers: {
        setBookmarkResource: (
            state,
            action: PayloadAction<IDataAPIBookmarkButton>,
        ) => {
            state.bookmarkId = action.payload.bookmarkId
            state.resourceId = action.payload.resourceId
            state.resourceType = action.payload.resourceType
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(createBookmark.pending, (state) => {
                state.isLoading = true
            })
            .addCase(createBookmark.fulfilled, (state) => {
                state.isLoading = false
            })

        builder
            .addCase(removeBookmark.pending, (state) => {
                state.isLoading = true
            })
            .addCase(removeBookmark.fulfilled, (state) => {
                state.isLoading = false
            })

        builder
            .addCase(fetchBookmark.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchBookmark.fulfilled, (state) => {
                state.isLoading = false
            })
    },
})

export const { setBookmarkResource } = bookmarkSlice.actions
export default bookmarkSlice.reducer

export const createBookmark = createAsyncThunk(
    "/Bookmark/Create",
    async (_, { dispatch, getState }) => {
        const { dataAPIBookmark: state } = getState() as GlobalState

        if (!state.resourceId) {
            return
        }

        const bookmarkId: number = await addBookmarkUsingDataApi(
            state.resourceType,
            state.resourceId,
        )
        dispatch(
            setBookmarkResource({
                ...state,
                bookmarkId: bookmarkId,
            }),
        )
    },
)

export const removeBookmark = createAsyncThunk(
    "Bookmark/Delete",
    async (_, { getState, dispatch }) => {
        const { dataAPIBookmark: state } = getState() as GlobalState

        if (!state.bookmarkId) {
            return
        }

        await removeBookmarkUsingDataApi(state.bookmarkId)
        dispatch(
            setBookmarkResource({
                ...state,
                bookmarkId: null,
            }),
        )
    },
)

export const fetchBookmark = createAsyncThunk(
    "/Bookmark/FetchByResourceId",
    async (_, { getState, dispatch }) => {
        const { dataAPIBookmark: state } = getState() as GlobalState

        if (!state.resourceId) {
            return
        }

        const bookmarkId = await findBookmarkUsingDataApi(
            state.resourceType,
            state.resourceId,
        )
        dispatch(
            setBookmarkResource({
                ...state,
                bookmarkId: bookmarkId,
            }),
        )
    },
)
